import { Box, Color, Display, DisplayPosition, ZIndex } from '@gousto-internal/citrus-react'
import React, { useEffect, useRef, useState } from 'react'
import { Background } from './components/Background/Background'
import { Carousel } from './components/Carousel/Carousel'
import { CTA } from './components/CTA/CTA'
import { GetStartedStickyCTA } from './components/GetStartedStickyCTA/GetStartedStickyCTA'
import { canUseWindow } from '@library/environment'

export type LandingPageAboveTheFoldProps = {
  onCTAClick: () => void
  signupCTA: string
}

export function LandingPageAboveTheFold({ onCTAClick, signupCTA }: LandingPageAboveTheFoldProps) {
  const heroRef = useRef<HTMLDivElement>(null)
  const [isHeroInView, setIsHeroInView] = useState(true)

  useEffect(() => {
    if (!canUseWindow) return

    const observer = new IntersectionObserver(([entry]) => setIsHeroInView(entry.isIntersecting), {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    })

    if (heroRef.current) {
      observer.observe(heroRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Box data-testid="landing-page-above-the-fold" ref={heroRef}>
      <Box
        position={DisplayPosition.Relative}
        display={Display.Flex}
        flexBasis={'100%'}
        width={'100%'}
        height={['580px', '610px']}
      >
        <Box
          width="100%"
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Mask}
          bottom={['-8px', '16px', null, '135px']}
        >
          <CTA onCTAClick={onCTAClick} signupCTA={signupCTA} />
        </Box>
        <Box
          minHeight={'610px'}
          width="100%"
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Masked}
        >
          <Carousel />
        </Box>
        <Box
          minHeight={'610px'}
          width="100%"
          display={Display.Flex}
          position={DisplayPosition.Absolute}
          zIndex={ZIndex.Default}
        >
          <Background />
        </Box>
      </Box>
      <Box position={DisplayPosition.Relative}>
        <Box
          position={DisplayPosition.Absolute}
          top="-1px"
          left="0"
          width="100%"
          height={['60%', null, null, '0%']} // Only display for mobile devices
          bg={Color.ColdGrey_800}
          zIndex={ZIndex.Auto}
        />
      </Box>
      {!isHeroInView && <GetStartedStickyCTA signupCTA={signupCTA} onCTAClick={onCTAClick} />}
    </Box>
  )
}
